import { injectable } from 'inversify'

import { ConvertedChartData } from '../protocols/UserChart'
import { BaseState } from './BaseState'

export type UserChartUploadConvertedData = ConvertedChartData & { baseName: string }

export interface UserChartUploadStateProps {
  file: File | null
  progress: number
  isFast: boolean
  // True once the transport (upload) reaches 100% and the server-side conversion
  // (+ client unzip) is running — a phase that reports no progress.
  converting: boolean
  error: string | null
  abortController: AbortController | null
  convertedData: UserChartUploadConvertedData | null
  // Epoch ms when the upload started — used to report the total UPLOAD-SUCCESS
  // duration once the chart is saved on the preview screen.
  startedAt: number | null
}

const INITIAL_STATE: UserChartUploadStateProps = {
  file: null,
  progress: 0,
  isFast: true,
  converting: false,
  error: null,
  abortController: null,
  convertedData: null,
  startedAt: null
}

@injectable()
export class UserChartUploadState extends BaseState<UserChartUploadStateProps> {
  constructor() {
    super(INITIAL_STATE)
  }

  setFile(file: File | null) {
    this._updateStateProp('file', file)
  }

  setProgress(progress: number) {
    this._updateStateProp('progress', progress)
  }

  setIsFast(isFast: boolean) {
    this._updateStateProp('isFast', isFast)
  }

  setError(error: string | null) {
    this._updateStateProp('error', error)
  }

  setAbortController(abortController: AbortController | null) {
    this._updateStateProp('abortController', abortController)
  }

  setConvertedData(convertedData: UserChartUploadConvertedData | null) {
    this._updateStateProp('convertedData', convertedData)
  }

  reset() {
    this.resetState()
  }
}
